import Image from "next/image";
import { useEffect, useRef, useState } from "react";
import { correctUrlString } from "@/utils/utils";
import Slider from "react-slick";
import { ChevronLeft, ChevronRight } from "lucide-react";

import bigCarousel_1 from "@/assets/images/listing/img_43.jpg";
import bigCarousel_2 from "@/assets/images/listing/img_44.jpg";
import bigCarousel_3 from "@/assets/images/listing/img_45.jpg";
import bigCarousel_4 from "@/assets/images/listing/img_46.jpg";

const MediaGallery = ({ data }: any) => {
  const images = correctUrlString(data?.attributes?.image_link) || [];
  // const images = [bigCarousel_1, bigCarousel_2, bigCarousel_3, bigCarousel_4];
  const sliderRef = useRef<Slider | null>(null);

  const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 3500,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: "30px",
    swipeToSlide: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: { centerPadding: "40px" },
      },
      { breakpoint: 900, settings: { centerPadding: "40px" } },
      { breakpoint: 600, settings: { centerPadding: "48px" } },
    ],
  };

  return (
    <>
      {data?.attributes?.image_link?.length > 0 && (
        <div className="position-relative">
          <button
            className="position-absolute start-0 top-50 translate-middle-y"
            onClick={() => sliderRef.current?.slickPrev()}
          >
            <ChevronLeft />
          </button>
          <Slider {...settings} ref={sliderRef} className="">
            {images.map((o, i) => {
              return (
                <div key={i}>
                  <Image
                    src={o}
                    alt="Product image"
                    fill
                    style={{
                      objectFit: "contain",
                      maxHeight: "100%",
                      width: "100%",
                    }}
                    className="border-20 position-relative"
                    sizes="(max-width: 768px) 100vw, (max-width: 1200px) 75vw, 60vw"
                  />
                </div>
              );
            })}
          </Slider>
          <button
            className="position-absolute end-0 top-50 translate-middle-y"
            onClick={() => sliderRef.current?.slickNext()}
          >
            <ChevronRight />
          </button>
        </div>
      )}
    </>
  );
};

export default MediaGallery;
